import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CodesParsed } from '../../interfaces/codes.types';

@Component({
  selector: 'app-form-control-color',
  templateUrl: './form-control-color.component.html',
  styleUrls: ['./form-control-color.component.scss']
})
export class FormControlColorComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() inputData: CodesParsed;

  constructor() { }

  ngOnInit() {
  }

}
